import { Form } from "@ant-design/compatible";

import ManagePortionForm from "./ManagePortionForm";

export default Form.create({
  name: "cultureForm",
})(ManagePortionForm);
